import PropTypes from 'prop-types';

const propType = {
  address: PropTypes.string,
  address_1: PropTypes.string,
  address_2: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  countryCode: PropTypes.string,
  id: PropTypes.string,
  location: PropTypes.arrayOf(PropTypes.number),
  state: PropTypes.string,
  zipCode: PropTypes.string,
};

export default { propType };
